module.exports = {
  switchVersion(e) {
    window.location.href = e.target.value;
  },
};
